<p class="block_title">Настройки уведомлений</p>
<hr>
<section class="notifications-settings">
  <!-- <div *ngIf="profile?.telegram_chat_id" class="block_msg_info">
    <span class="notifications-settings__title">
      <font color="red">Внимание.</font><br>
      На данный момент уведомления в разработке.
    </span>
  </div> -->
  <div *ngIf="!profile?.telegram_chat_id" class="telegram-notifications block_msg_info">
    <p>Для того чтобы уведомления приходили в Telegram, 
      <br>перейдите по ссылке и запустите бота, 
      <br>затем вставте полученный код в форму ниже</p>
    <a href="http://t.me/SmartUp_school_bot" target="_blank">Подписаться в Telegram</a>

    <div class="auth-code_form">
      <form [formGroup]="authCodeForm" (ngSubmit)="onSubmitAuthCode()">
        <p>Код подтвеждения Telegram подписки</p>
        <mat-form-field hintLabel="" appearance="outline">
          <mat-label>Telegram код</mat-label>
          <input matInput placeholder="Код подтверждения Telegram" formControlName="authCode" type="number">
          <mat-error *ngIf="authCodeForm.controls.authCode.invalid">Некоректный код</mat-error>
        </mat-form-field>

        <button [disabled]="authCodeForm.controls.authCode.invalid" mat-raised-button color="primary" type="submit">Отправить</button>
      </form>
    </div>
  </div>
  <div class="settings_form">
      <mat-checkbox *ngIf="profile?.telegram_chat_id" 
        [checked]="isUpdateTelegramSettings"
        (change)="telegramCheckboxHandler()"
        [value]="isUpdateTelegramSettings">Рассылка в Telegram</mat-checkbox>
      <mat-checkbox
        [checked]="isUpdateEmailSettings"
        (change)="emailCheckboxHandler()"
        [value]="isUpdateEmailSettings">Рассылка на Email</mat-checkbox>
    </div>

</section>
